import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  cancelButton: {
    marginRight: theme.spacing(1),
  },
  ctaButton: {
    minWidth: '124px',
    width: 'auto',
  },
  stackedButtons: {
    '& $cancelButton': {
      width: '100%',
    },
    '& button': {
      height: theme.spacing(6),
    },
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
}));

export default useStyles;
